module.exports = __webpack_public_path__ + "static/img/上海合作组织.67c78a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/上海合作组织.png
// module id = U8hG
// module chunks = 1